import React, { Component } from 'react'

export class Prestaciones extends Component {
    render() {
        return (
            <div style={{padding: '3% 6%'}} >

                <h3 className="inicio-title">Prestaciones en especies</h3>
                <p>
                •   Asistencia médica 24hs. por accidentes de trabajo o enfermedades profesionales.<br/>
                •   Emergencias y traslados sanitarios terrestres y aéreos.<br/>
                •   Servicio de Telemedicina para el seguimiento, control y auditoría de las evoluciones de los tratamientos.<br/>
                •   Rehabilitación integral, trabajo social y calificación profesional.<br/>
                •   Cobertura completa del trabajador hasta el alta médica, incluyendo traslado, estudios médicos, cirugías, medicamentos, prótesis, etc.<br/>
                •   Atención Odontológica y de Salud Mental en todo el país.<br/>
                •   Realización de Exámenes Médicos Periódicos e Integrales a la población expuesta.<br/>
                •   Analistas y auditores médicos durante todo el proceso de evolución y recuperación del paciente, con el objeto de lograr un tratamiento acorde a cada tipo de siniestro.<br/>
                •   Reintegro de gastos médicos cuando los mismos fueran afrontados ante una necesidad que lo justifique para una más adecuada atención.<br/>
                •   Servicio fúnebre.<br/>
                </p><p/><p/>

                <h3 style={{'font-size': 'x-large'}} className="inicio-title">Red de prestadores distribuida en todo el país acorde a las necesidades de cada jurisdicción</h3>
                <p>
                Damos cobertura ante accidentes de trabajo y enfermedades laborales a los que día a día producen, acondicionan y procesan los alimentos que brinda nuestra tierra que consumen 44 millones de argentinos y cerca de 400 millones de personas en todo el mundo.
                </p>
                    Tan elevado compromiso hace que dispongamos, ademas de la Red de Atención de nuestra Obra Social OSPRERA, con distribución de alcance nacional, la incorporación de Prestadores con experiencia en accidentología laboral y de alta calidad en las especialidades necesarias en todo el país, abarcando todos los niveles de atención para una atención completa y de gran satisfacción para quienes la requieran, incorporando atención por Telemedicina de alto impacto positivo en esta época de pandemia por Covid-19.
                <p/><p/><p/>

                <h3 className="inicio-title">Prestaciones dinerarias</h3>
                <p>
                ART Mutual Rural dispone de procedimientos administrativos agiles, que permiten al trabajador rural percibir, o reintegrar al empleador, sus compensaciones en tiempo y forma.<br/>
                •   Reconocimiento de la ILT - Indemnización Laboral Temporaria.<br/>
                •   Reconocimiento de la ILP - Indemnización Laboral Permanente (Total o Parcial).<br/>
                •   Indemnizaciones por fallecimiento a derechohabientes.<br/>
                
                </p> <p/><p/>
            </div>
        )
    }
}

export default Prestaciones
